export { getServiceOrRegister } from './legacy-services/index.js';
export { getService, registerService } from './singleton.js';
